export default "__VITE_ASSET__BheVAo6H__"